import { Button, CircularProgress } from '@mui/material';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';

import { showErrorAction } from 'containers/Notification/actions';
import { ActionVisibilityStatus, useCreateActionFromTemplateMutation } from 'generated/graphql';

import { ActionTemplate } from '../types';

export const CreateActionFromTemplateButton = ({
  actionTemplate,
}: {
  actionTemplate: ActionTemplate;
}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [createActionFromTemplate, { loading: isImporting }] = useCreateActionFromTemplateMutation({
    onError: () => {
      dispatch(showErrorAction('An error occurred, please try again.'));
    },
  });

  if (actionTemplate.status !== ActionVisibilityStatus.Published) {
    return null;
  }

  const createActionFromTemplateHandler = async () => {
    const result = await createActionFromTemplate({
      variables: {
        templateId: actionTemplate.id,
      },
    });

    const createdActionId = result.data?.createActionFromTemplate?.id;
    if (createdActionId) {
      history.push(`/actions/edit/${createdActionId}`);
    }
  };
  return (
    <>
      <Button
        color="primary"
        variant="contained"
        disabled={isImporting}
        onClick={() => {
          void createActionFromTemplateHandler();
        }}
        style={{ margin: '0 0 8px 8px' }}
      >
        {isImporting ? <CircularProgress size={20} /> : <>Create Action</>}
      </Button>
    </>
  );
};
